<template>
  <artisio-modal size="xl" :visible="modal.show" :title="$t(`DPV Details`)" @hidden="hideModal" :hide-footer="true"
      scrollable>
    <DpvLotsTable/>
  </artisio-modal>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import DpvLotsTable from "./DpvLotsTable";

  const {mapState, mapActions} = createNamespacedHelpers('dpv/dpv');

  export default {
    name: "DpvLotsModal",
    components: {ArtisioModal, DpvLotsTable},
    computed: {
      ...mapState({
        modal: state => state.modal,
      })
    },
    methods: {
      ...mapActions(['hideModal']),
    }
  }
</script>

<style lang="scss" scoped>
</style>
